import CardTitle from "./CardTitle";

const Ambition = () => {
   return [
      <div>
         <CardTitle num={1} />
         <ul>
            <li>
               Everyone is a decision maker on certain things, they do it
               brilliantly, and in consultation with others
            </li>
            <li>
               The decisions that you are accountable for are made clear to you
               in the course of your job role
            </li>
         </ul>
      </div>,
      <div>
         <CardTitle num={2} />
         <ul>
            <li>
               Meetings are designed to get things done or move things faster
            </li>
         </ul>
      </div>,
      <div>
         <CardTitle num={3} />
         <ul>
            <li>Fail fast, pivot faster</li>
         </ul>
      </div>,
      <div>
         <CardTitle num={4} />
         <ul>
            <li>Purpose even over status quo </li>
            <li>Exceptional execution even over breakthrough ideas</li>
         </ul>
      </div>,

      <div>
         <CardTitle num={5} />
         <h3>We smile at: 😍</h3>
         <ul>
            <li>Problem solvers</li>
            <li>Excellence </li>
            <li>Optimism</li>
         </ul>
         <br />
         <h3>We frown at: 😒</h3>
         <ul>
            <li>Mediocrity </li>
            <li>Status slinging </li>
            <li>Going rogue for its own sake </li>
            <li>Problem finders without problem solutions</li>
         </ul>
      </div>,
      <div>
         <CardTitle num={6} />
         <ul>
            <li>
               Regular recognition of notable contribution to key business
               metrics
            </li>
         </ul>
      </div>,
      <div>
         <CardTitle num={7} />
         <ul>
            <li>
               Everyone is invested in helping everyone else do remarkable work,
               and feedback is critical in helping people do remarkable work
            </li>
         </ul>
      </div>,
      <div>
         <CardTitle num={8} />
         <ul>
            <li>
               Let go of sacred cows (the things we hold onto because we’re
               precious!)
            </li>
            <li>
               We share our ideas openly and test them to see if it’s worth more
               time and money
            </li>
         </ul>
      </div>,
   ];
};

export default Ambition;
